var map = {
	"./img_1.jpg": 62758,
	"./img_2.jpg": 34784,
	"./img_3.jpg": 41974,
	"./img_4.jpg": 3255,
	"./img_5.jpg": 3387,
	"./img_6.jpg": 11209,
	"./img_7.jpg": 90319,
	"./img_8.jpg": 44726
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70325;